import {PRODUCT_SELECTION} from './queries';

// There is no deleteProduct: a draft cannot be removed through this API.
export const createProduct = `
   mutation createProduct($input: CreateProductInput!) {
       createProduct(input: $input) {${PRODUCT_SELECTION}}
   }
`;

// `input.expectedVersion` is the version the client read. A stale one comes
// back as a ConflictError and nothing is written.
export const updateProduct = `
   mutation updateProduct($input: UpdateProductInput!) {
       updateProduct(input: $input) {${PRODUCT_SELECTION}}
   }
`;
